__turbopack_context__.v({
  "className": "fira_code_d0cbcfbb-module__Uxe4ZW__className",
});
